import { Clock3, Music2, Repeat, SlidersHorizontal, Volume2 } from "lucide-react";
import type { Instrument } from "../data/instruments";
import { useI18n } from "../i18n/LocaleContext";
import { KeyboardMappingPanel } from "./KeyboardMappingPanel";

interface TransportBarProps {
  instrument: Instrument;
  pressedKeys: string[];
  onOrnament: (ornament: string) => void;
  onControl: (controlId: string, value?: number | string | boolean) => void;
}

export function TransportBar({ instrument, pressedKeys, onOrnament, onControl }: TransportBarProps) {
  const { t } = useI18n();

  return (
    <footer className="bottom-control-bar" data-testid="bottom-control-bar" aria-label="Transport and performance utilities">
      <KeyboardMappingPanel instrument={instrument} pressedKeys={pressedKeys} />
      <div className="utility-controls">
        <button type="button" aria-label="Trigger bend ornament" onClick={() => onOrnament("bend")}>
          <Music2 size={18} aria-hidden="true" />
          <span>{t.transport.bend}</span>
        </button>
        <button type="button" aria-label="Trigger vibrato ornament" onClick={() => onOrnament("vibrato")}>
          <SlidersHorizontal size={18} aria-hidden="true" />
          <span>{t.transport.vibrato}</span>
        </button>
        <button type="button" aria-label="Toggle drone" onClick={() => onControl("drone_toggle")}>
          <Volume2 size={18} aria-hidden="true" />
          <span>{t.transport.drone}</span>
        </button>
        <button type="button" aria-label="Loop placeholder" onClick={() => onControl("loop_placeholder", true)}>
          <Repeat size={18} aria-hidden="true" />
          <span>{t.transport.loop}</span>
        </button>
        <button type="button" aria-label="Metronome placeholder" onClick={() => onControl("metronome_placeholder", true)}>
          <Clock3 size={18} aria-hidden="true" />
          <span>{t.transport.metro}</span>
        </button>
      </div>
    </footer>
  );
}
